<div class="pull-left">
  <h4>KPI Stage Results</h4>
</div>
<div class="pull-right">
  <button mat-raised-button class="btn button-fix button-color-fix-purple" (click)="checkKPIStageResultsHistory($event)">
    Check KPI Stage History <mat-icon class="icon-color-fix custom-icon-style">history</mat-icon>
  </button>
</div>
<div style="width:550px">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="form-group col-lg-12">
        <label>Kpi Period</label>
        <div class="col-lg-11" style="position:relative">
          <input [matDatepicker]="kpiPeriodDatePicker"
            [(ngModel)]="data.kpiPeriod"
            class="form-control"
            formControlName="kpiPeriod"
            (dateChange)="getDateUTCChange($event, 'kpiPeriod')"
            readonly />
            @if (form.get('kpiPeriod')?.value) {
              <button mat-icon-button matSuffix (click)="clearDate('kpiPeriod')" class="clear-icon">
                <mat-icon>clear</mat-icon>
              </button>
            }
          </div>
          <div class="col-lg-1" style="padding-left:0">
            <mat-datepicker-toggle matSuffix [for]="kpiPeriodDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #kpiPeriodDatePicker></mat-datepicker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-6">
          <label>Average Overarching Stage</label>
          <div style="position:relative">
            <mat-form-field appearance="outline">
              <input matInput type="number"
                class="form-control"
                [(ngModel)]="data.avOverarchStage"
                step="0.1"
                min="0"
                max="4"
                pattern="^\d+(\.\d{1})?$"
                formControlName="avOverarchStage" />
                @if (form.get('avOverarchStage')?.hasError('min') || form.get('avOverarchStage')?.hasError('max')) {
                  <mat-error>
                    Value must be between 0.0 and 4.0
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <label>Average SER Stage</label>
            <div style="position:relative">
              <mat-form-field appearance="outline">
                <input matInput type="number"
                  class="form-control"
                  [(ngModel)]="data.avSerStage"
                  step="0.1"
                  min="0"
                  max="4"
                  pattern="^\d+(\.\d{1})?$"
                  formControlName="avSerStage" />
                  @if (form.get('avSerStage')?.hasError('min') || form.get('avSerStage')?.hasError('max')) {
                    <mat-error>
                      Value must be between 0.0 and 4.0
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label>Average NI Stage</label>
              <div style="position:relative">
                <mat-form-field appearance="outline">
                  <input matInput type="number"
                    class="form-control"
                    [(ngModel)]="data.avNiStage"
                    step="0.1"
                    min="0"
                    max="4"
                    pattern="^\d+(\.\d{1})?$"
                    formControlName="avNiStage" />
                    @if (form.get('avNiStage')?.hasError('min') || form.get('avNiStage')?.hasError('max')) {
                      <mat-error>
                        Value must be between 0.0 and 4.0
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <label>Average MOD Stage</label>
                <div style="position:relative">
                  <mat-form-field appearance="outline">
                    <input matInput type="number"
                      class="form-control"
                      [(ngModel)]="data.avModStage"
                      step="0.1"
                      min="0"
                      max="4"
                      pattern="^\d+(\.\d{1})?$"
                      formControlName="avModStage" />
                      @if (form.get('avModStage')?.hasError('min') || form.get('avModStage')?.hasError('max')) {
                        <mat-error>
                          Value must be between 0.0 and 4.0
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="panel-body">
                  <button (click)="backButtonHandler($event)" mat-raised-button class="btn  button-color-fix_red ">
                    <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
                    Back
                  </button>
                  <button mat-raised-button type="submit" class="btn button-color-fix pull-right">
                    Save
                    <mat-icon class="icon-color-fix">save</mat-icon>
                  </button>

                </div>
              </div>
            </form>
          </div>